"use strict";

exports.__esModule = true;
exports.ajax = exports.getCgiParms = void 0;

require("core-js/modules/es.object.assign.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

var _ajax = _interopRequireDefault(require("@tencent/midas-libs/dist/lib/ajax"));

var _xMidas = require("./x-midas");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCgiParms = function getCgiParms(params) {
  return Object.assign({
    pf: 'vip_m-pay_html5-html5',
    pfkey: 'pfkey',
    mid: 'r',
    from_h5: 1,
    r: Math.random(),
    openkey: 'nokey',
    session_id: 'hy_gameid',
    session_type: 'st_dummy'
  }, params);
};

exports.getCgiParms = getCgiParms;

var ajax = function ajax(options) {
  var param = {};

  if (options.param) {
    var encrypt_res = (0, _xMidas.xMidasEncrypt)(options.param);
    Object.keys(encrypt_res).forEach(function (key) {
      encrypt_res[key] = encodeURIComponent(encrypt_res[key]);
    });
    param = encrypt_res;
  }

  return (0, _ajax.default)(Object.assign({}, options, {
    param: param
  }));
};

exports.ajax = ajax;